import type { AppsSearchTableState } from "./types";

const DEFAULT_PAGE = 1;
const DEFAULT_PAGE_SIZE = 50;

const initialAppsSearchState: AppsSearchTableState = {
    tableParams: {
        page: DEFAULT_PAGE,
        pageSize: DEFAULT_PAGE_SIZE,
    },
    searchText: "",
    isRowSelectionEnabled: false,
    selectedRows: [],
};

export default initialAppsSearchState;
